import { render, staticRenderFns } from "./RoundFilterButton.vue?vue&type=template&id=315e4802&"
import script from "./RoundFilterButton.vue?vue&type=script&lang=ts&"
export * from "./RoundFilterButton.vue?vue&type=script&lang=ts&"
import style0 from "./RoundFilterButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports